import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const AYLAR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

export const buAyTR = () => {
  const s = new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" });
  return { yil: Number(s.slice(0, 4)), ay: Number(s.slice(5, 7)) };
};

export const donemEtiketi = (yil, ay) => (ay ? `${AYLAR[ay - 1]} ${yil}` : `${yil} — Tüm Yıl`);

export const AyYilSecici = ({ yil, ay, onChange, testid = "ay-yil-secici" }) => {
  const buYil = buAyTR().yil;
  const yillar = [buYil - 1, buYil, buYil + 1];
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <Select value={ay ? String(ay) : "tumu"} onValueChange={(v) => onChange({ yil, ay: v === "tumu" ? null : Number(v) })}>
        <SelectTrigger className="h-10 w-[150px]" data-testid={`${testid}-ay`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="tumu">Tüm Yıl</SelectItem>
          {AYLAR.map((a, i) => (
            <SelectItem key={a} value={String(i + 1)}>{a}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={String(yil)} onValueChange={(v) => onChange({ yil: Number(v), ay })}>
        <SelectTrigger className="h-10 w-[96px]" data-testid={`${testid}-yil`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {yillar.map((y) => (
            <SelectItem key={y} value={String(y)}>{y}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
